import { Link } from "react-router-dom";

export const Logo = ({ to = "/", testId = "brand-logo-link" }) => (
  <Link to={to} className="group flex items-center gap-3" data-testid={testId}>
    <span className="relative flex h-9 w-9 items-center justify-center rounded-lg border border-emerald-500/40 bg-emerald-500/10">
      <span className="absolute inset-x-2 bottom-2 h-[2px] bg-amber-600" />
      <span className="font-display text-lg font-bold leading-none text-emerald-400 transition-transform duration-300 group-hover:-translate-y-0.5">M</span>
    </span>
    <span className="leading-tight">
      <span className="block font-display text-base font-semibold tracking-tight text-white">Meridian</span>
      <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-slate-400">Stock Exchange</span>
    </span>
  </Link>
);
